import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from '@/utils';
export default {
  name: 'goods_drawer_basic_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    styleId: [Number, String],
    channelId: [Number, String]
  },
  data: function data() {
    return {
      rules: {
        name: [{
          required: true,
          message: '名称不可为空',
          trigger: 'change'
        }, {
          min: 1,
          max: 10,
          message: '字数应大于等于1个字符小于10个字符!',
          trigger: 'change'
        }],
        more_name: [{
          required: true,
          message: '更多按钮名称不可为空',
          trigger: 'change'
        }, {
          min: 1,
          max: 10,
          message: '字数应大于等于1个字符小于10个字符!',
          trigger: 'change'
        }],
        bg_color: [{
          required: true,
          message: '背景色不可为空',
          trigger: 'change'
        }],
        id: [{
          required: true,
          message: '菜单不可为空',
          trigger: 'change'
        }],
        sort: [{
          required: true,
          message: '展示逻辑不可为空',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    if (isEmpty(this.value.config)) {
      this.$set(this.value, 'config', {
        name: '',
        more_name: '查看更多',
        bg_color: '#ffffff',
        id: '',
        sort: '1'
      });
    }
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index //兼容新老组件 默认预置2
    }));
  },
  computed: {
    menuListFilter: function menuListFilter() {
      var list = JSON.parse(JSON.stringify(this.menuList));
      return list.map(function (i) {
        if (i.type === 'online_order') {
          i.childrens = i.childrens.map(function (c) {
            return _objectSpread(_objectSpread({}, c), {}, {
              disabled: true
            });
          });
        }
        return _objectSpread(_objectSpread({}, i), {}, {
          disabled: i.disabled || i.group_type == 2 // 组合菜单 禁止选择一级菜单
        });
      });
    }
  }
};